<div class="row">
  <div class="col-md-12 col-lg-3 m-t-sm">
    <img src="{{qrCodeUrl}}" class="qr-image" />
  </div>
  <div class="col-md-12 col-lg-9 m-t-sm">
    <form (ngSubmit)="validateQrCode()">
      <div class="p-inputgroup">
        <input type="text" placeholder="{{ 'LoginView.verificationCode' | translate }}" [(ngModel)]="user2faCode"
          [ngModelOptions]="{ standalone: true }" autofocus tabindex="4">
        <button pButton type="button" icon="fa fa-check" class="p-button-warn" [disabled]="!qrCodeUrl || !user2faCode"
          tabindex="5" (debounceClick)="validateQrCode()" appDebounceClick
          label="{{'General.validate' | translate }}"></button>
      </div>
    </form>
  </div>
  <div class="col-12 p-2 text-center" *ngIf="errorMsg">
    <span class="text-danger">
      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{ errorMsg }}</span>
  </div>
</div>
<div class="m-t-md" [innerHTML]="'TwoFactor.userprefs.instructions' | translate"></div>